import { AudiogramProps } from '@mi-front/audiogram';
import { NullMessage } from '@ui/components';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { AudiogramPlayer } from '../social-export/AudiogramPlayer';
import { AudiogramFormValues } from './AudiogramGenerator';
import { VariantSelector } from './VariantSelector';

interface Props extends Partial<AudiogramProps> {
  variants: string[];
}

export function AudiogramlPlayerInForm(props: Props) {
  const { variants, ...rest } = props;

  const { watch } = useFormContext<AudiogramFormValues>();

  const data = watch('data');

  const [variant, setVariant] = useState(props.variants[0]);

  useEffect(() => {
    if (!props.variants.includes(variant)) {
      setVariant(props.variants[0]);
    }
  }, [props.variants]);

  if (props.variants.length === 0) {
    return (
      <NullMessage>
        <FormattedMessage
          id="audiogram.selectAtLeastOneVariant"
          defaultMessage="Debe seleccionar al menos una variante"
        />
      </NullMessage>
    );
  }

  return (
    <div>
      <VariantSelector variants={variants} value={variant} onChange={setVariant} />
      <AudiogramPlayer
        audiogramProps={{
          ...rest,
          ...data,
          variant: variant as AudiogramProps['variant'],
        }}
      />
    </div>
  );
}
